module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/DesktopHero-956af2d3dd4aee57f626c6595bfdbc23.mp4";